import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Protected, ProtectedPage } from "./pages/Protected";
import { HomePage } from "./pages/home/HomePage";
import { LoginPage } from "./pages/login/login";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { RegisterPage } from "./pages/login/register";
import { ForgotPasswordPage } from "./pages/forgot-password/forgot-password";
// import { Dashboard } from "./pages/gas_dashboard/Dashboard.jsx";

function App() {
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              // <Protected>
              <Navigate to="/home" />
              // </Protected>
            }
          />
          <Route
            path="/home"
            element={
              <ProtectedPage children={<HomePage />} pageId="home" showPopUp={false} />

            }
          />
                    {/* <Route path="/dashboard" element={<Dashboard />} /> */}

          {/* <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} /> */}

        </Routes>
      </BrowserRouter>
      <div className="betaText">Beta Version</div>
    </>
  );
}

export default App;
